import React, { useEffect } from 'react';
import { LoadingOutlined } from "@ant-design/icons";
import liracrypt from './Liracrypt/liracrypt';

const OutputBlocks = ({
    data
}) => {
    const [img, setImg] = React.useState(null);
    const [imgLoading, setImgLoading] = React.useState(true);
    const blocks = [
        {
            "style": {
                "top": "1%",
                "color": "#000000",
                "left": "0%",
                "width": "39%",
                "height": "8%",
                "fontSize": "1vw",
                "background": "red",
                "textAlign": "center"
            },
            "text": "Place 1"
        },
        {
            "style": {
                "top": "28%",
                "color": "#000000",
                "left": "39.5%",
                "width": "15%",
                "height": "8%",
                "fontSize": "1vw",
                "background": "green"
            },
            "text": "Place 2"
        },
        {
            "style": {
                "top": "55%",
                "color": "#000000",
                "left": "86%",
                "width": "13%",
                "height": "8%",
                "fontSize": "1vw",
                "background": "yellow"
            },
            "text": "Place 3"
        },
    ];

    const getImg = () => {
        liracrypt.get(data.img?.api, { ...data.img?.params })
            .then(({ data }) => {
                setImg(data.data);
                setImgLoading(false);
                if (data.img?.isCacheable) {
                    localStorage.setItem(data.img?.cacheKey, data.data);
                }
            }).catch(err => {
                console.error("Error fetching image:", err);
            });
    }

    useEffect(() => {
        setImgLoading(true);
        if (data.img?.isCacheable) {
            let cacheImg = localStorage.getItem(data.img?.cacheKey);
            if (cacheImg) {
                setImg(cacheImg);
                setImgLoading(false);
                return;
            } else {
                getImg();
            }
        } else {
            getImg();
        }

    }, []);

    return (
        <div>
            <div id="image-form-container" className="img-form" style={{ position: 'relative', width: '100%' }}>
                {
                    imgLoading ? <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <LoadingOutlined style={{ fontSize: 80, color: "#0070c0ff" }} spin />
                    </div> :
                        <>
                            <img src={img} alt="form" style={{ width: '100%', display: 'block' }} />
                            {
                                data.blocks?.map((input, index) => (
                                    <div style={{ position: 'absolute', ...input.style }}>{input.text}</div>
                                ))
                            }
                        </>
                }
            </div>
        </div>
    )

};

export default OutputBlocks;